import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfHardBreak = React.memo(({ node }: AdfNodeProps) => {
    return <br />;
});
